<template>
  <div
    id="content-navigation"
    class="d-flex flex-column flex-grow-1">
    <!-- Content Section Navigation -->
    <nav class="mb-3">
      <h3 class="px-5 mb-3">Section</h3>
      <v-btn
        class="plain py-2 px-5 justify-start"
        to="/content/all"
        @click="handleContentFilterSelection('all')"
        block>
        <v-icon class="mx-5">mdi-text-box-multiple-outline</v-icon>
        All
      </v-btn>
      <v-btn
        v-for="contentGroup in contentGroups"
        :key="contentGroup"
        :to="`/content/${contentGroup.toLowerCase()}`"
        @click="handleContentFilterSelection(contentGroup.toLowerCase())"
        class="plain py-2 px-5 justify-start"
        block>
        <v-icon class="mx-5">mdi-text-box-outline</v-icon>
        {{contentGroup | startCase}}
      </v-btn>
    </nav>
    <!-- / Content Section Navigation -->

    <!-- Content Type Navigation -->
    <nav class="mb-3">
      <h3 class="px-5 mb-3">Type</h3>
      <v-btn
        class="plain py-2 px-5 justify-start"
        to="/content/text"
        @click="handleContentFilterSelection('text')"
        block>
        <v-icon class="mx-5">mdi-text-box-multiple-outline</v-icon>
        Text
      </v-btn>
      <v-btn
        class="plain py-2 px-5 justify-start"
        to="/content/code"
        @click="handleContentFilterSelection('code')"
        block>
        <v-icon class="mx-5">mdi-code-tags</v-icon>
        Code
      </v-btn>
      <v-btn
        class="plain py-2 px-5 justify-start"
        to="/content/image"
        @click="handleContentFilterSelection('image')"
        block>
        <v-icon class="mx-5">mdi-image-multiple-outline</v-icon>
        Images
      </v-btn>
      <v-btn
        class="plain py-2 px-5 justify-start"
        to="/content/colors"
        @click="handleContentFilterSelection('colors')"
        block>
        <v-icon class="mx-5">mdi-palette</v-icon>
        Colors
      </v-btn>
    </nav>
    <!-- / Content Type Navigation -->
  </div>
</template>

<script>
import ContentItemMixin from '../mixin.content-item';

export default {
  name: 'ContentNavigation',
  mixins: [
    ContentItemMixin,
  ],

};
</script>

<style lang="scss"></style>
